import type { Icon } from "@phosphor-icons/react";
import clsx from "clsx";
import type React from "react";

export const GameStat: React.FC<{
  label: string;
  icon: Icon;
  value: number;
  isReverse?: boolean;
}> = ({ label, icon: Icon, value, isReverse }) => {
  return (
    <div
      data-tip={label}
      className={clsx(
        "tooltip flex items-center gap-1 text-lg font-medium tabular-nums lg:text-xl",
        isReverse && "flex-row-reverse",
      )}
    >
      <Icon className="size-5 lg:size-6" weight="bold" />
      <span className="text-base-content">{value.toLocaleString()}</span>
    </div>
  );
};
